import { BannerContent } from '@fingertip/creator-proto/gen/fingertip/common/type/v1/block_schema_pb'

import { BlockProps } from '../shared/block-switch'
import { MediaImage } from '../shared/media-image'
import { getFullHeight, getFullWidth } from '../shared/utils'

export const BannerBlock = ({ block, w, h, y, scaleFactor }: BlockProps) => {
  const content = block?.content?.content?.value as BannerContent
  const hasAsset = !!content?.media?.type

  const WIDTH = getFullWidth(w, scaleFactor)
  const HEIGHT = getFullHeight(h, scaleFactor)

  return (
    <div className="flex size-full items-center overflow-hidden rounded-page-widget-inner">
      {hasAsset && (
        <>
          <MediaImage
            media={content?.media}
            className="absolute overflow-hidden rounded-page-widget-inner object-cover"
            width={WIDTH}
            height={HEIGHT}
            priority={y < 6}
            style={{
              width: '100%',
              height: '100%',
              left: 0,
              top: 0,
            }}
          />
        </>
      )}

      <div
        className="px-block prose:text-current prose prose-base z-10 w-full text-current prose-headings:font-page-heading prose-headings:font-page-heading-weight prose-headings:text-current prose-p:text-current prose-a:text-current prose-a:underline prose-strong:text-current prose-em:text-current"
        dangerouslySetInnerHTML={{ __html: content?.text || '' }}
      />
    </div>
  )
}
